import {Route, Routes } from "react-router-dom";
import './App.css';
import Header from './layouts/header';
import Footer from './layouts/footer';
import Accueil from './pages/accueil';
import Privacy from "./pages/privacy";
import Use from "./pages/use";
import Reimbursement from "./pages/Reimbursement";
import { LanguageProvider } from './i18n/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Header />
      <Routes>
        <Route path="/" element={<Accueil />}/>
        <Route path="/privacypolicy" element={<Privacy />}/>
        <Route path="/termsandconditions" element={<Use />}/>
        <Route path="/refundpolicy" element={<Reimbursement />}/>
      </Routes>
      <Footer/>
    </LanguageProvider>
  );
}

export default App;
